import { Link, useLocation } from 'react-router'
import { ChevronRight, Home } from 'lucide-react'

/**
 * Auto-generated breadcrumbs based on URL path.
 * Place in pages that don't have manual breadcrumbs.
 */

const LABELS: Record<string, string> = {
  services: 'Services',
  'guide-prix': 'Guide des prix',
  blog: 'Blog',
  contact: 'Contact',
  'a-propos': 'À propos',
  faq: 'FAQ',
  inspiration: 'Inspiration',
  calculateur: 'Calculateur',
  'demande-devis': 'Demande de devis',
  recherche: 'Recherche',
  login: 'Connexion',
  register: 'Inscription',
  'register-pro': 'Inscription Pro',
  'espace-pro': 'Espace Pro',
  'tableau-de-bord': 'Tableau de bord',
  'devenir-pro': 'Devenir partenaire',
  prix: 'Prix',
  trouver: 'Trouver',
  devis: 'Devis',
  urgence: 'Urgence',
  tarif: 'Tarif',
  pro: 'Professionnel',
  'forgot-password': 'Mot de passe oublié',
  'reset-password': 'Réinitialiser le mot de passe',
  'mentions-legales': 'Mentions légales',
  confidentialite: 'Confidentialité',
  cgv: 'CGV',
  avis: 'Avis',
  profil: 'Profil',
  abonnement: 'Abonnement',
  leads: 'Leads',
  parametres: 'Paramètres',
  demandes: 'Demandes',
}

export function AutoBreadcrumb() {
  const location = useLocation()
  const parts = location.pathname.split('/').filter(Boolean)

  if (parts.length === 0) return null
  if (location.pathname.includes('demande-devis')) return null
  // Pages that have their own manual breadcrumbs
  if (location.pathname.match(/^\/services\/.+/)) return null
  if (location.pathname.match(/^\/pro\//)) return null
  // Routes whose INTERMEDIATE path segments have no matching hub route, so the
  // auto-crumbs 404 (GSC audit 2026-07 — dead breadcrumb links waste crawl
  // budget + break nav). Verified 404: /tarifs/{svc}, /tarifs/{svc}/{city}
  // (2-seg route resolves by artisan slug, not service slug); /cee/{op};
  // /rge/{svc}; /devis-ville, /devis-ville/{svc}; /travaux (no index route).
  // These pages either carry their own BreadcrumbSchema (money pages) or are
  // noindex, so dropping the auto-crumb is pure win. /problemes stays enabled —
  // its crumbs (/problemes, /problemes/{slug}) all resolve.
  if (location.pathname.match(/^\/(prix|trouver|devis|devis-ville|urgence|tarif|tarifs|guide-prix|cee|rge|travaux)\/.+/)) return null
  if (location.pathname.match(/^\/blog\/.+/)) return null
  if (location.pathname.match(/^\/(espace-pro|tableau-de-bord)/)) return null
  if (location.pathname.match(/^\/(login|register|forgot-password|reset-password|verify-email)/)) return null

  const crumbs = parts.map((part, i) => {
    const href = '/' + parts.slice(0, i + 1).join('/')
    const label = LABELS[part] ?? decodeURIComponent(part).replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
    const isLast = i === parts.length - 1
    return { href, label, isLast }
  })

  return (
    <nav className="border-t border-slate-100 bg-slate-50/60" aria-label="Breadcrumb">
      <div className="mx-auto flex max-w-7xl items-center gap-1.5 px-4 py-1.5 lg:px-6">
        <Link to="/" className="text-slate-400 hover:text-primary">
          <Home className="h-3.5 w-3.5" />
        </Link>
        {crumbs.map((crumb) => (
          <span key={crumb.href} className="flex items-center gap-1.5">
            <ChevronRight className="h-3 w-3 text-slate-300" />
            {crumb.isLast ? (
              <span className="truncate text-xs font-medium text-slate-700">{crumb.label}</span>
            ) : (
              <Link to={crumb.href} className="truncate text-xs text-slate-400 hover:text-primary">
                {crumb.label}
              </Link>
            )}
          </span>
        ))}
      </div>
    </nav>
  )
}
